import React from "react";

import { IHttpRequestConfig } from "@/browser";
import { getAttachmentMeta } from "@/data/attachments";

import { Fetcher, IFetcherProps } from "./Fetcher";

interface Props {
  systemId: string;
  children: IFetcherProps["children"];
}

export class LazyImg extends React.PureComponent<Props> {
  handleFetch = (httpConfig: IHttpRequestConfig) => {
    const { systemId } = this.props;
    return getAttachmentMeta({ systemId }, httpConfig);
  };

  render() {
    const { children } = this.props;

    return <Fetcher fetchData={this.handleFetch}>{children}</Fetcher>;
  }
}
